export enum HostAssignType {
  None = 1,
  RoundRobin = 2,
}
